/* Ability Warehouse — instant filters, sorting and endless scroll for collection and search pages */
(function () {
  'use strict';
  var root = document.querySelector('[data-catalog]');
  if (!root || !window.CWIndex) return;
  var X = window.CWIndex;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

  var mode = root.dataset.mode;                     // 'collection' | 'search'
  var groups = [];
  try { groups = JSON.parse(root.dataset.groups || '[]'); } catch (e) {}
  var presetTags = (root.dataset.tags || '').split(',').filter(Boolean);
  var BATCH = 24;

  var grid = $('[data-cat-grid]');
  var facetsEl = $('[data-cat-facets]');
  var countEl = $('[data-cat-count]');
  var pillsEl = $('[data-cat-pills]');
  var sortEl = $('[data-cat-sort]');
  var qEls = $$('[data-cat-q]').concat(Array.prototype.slice.call(document.querySelectorAll('[data-cat-q-ext]')));
  var moreEl = $('[data-cat-more]');
  var sentinel = $('[data-cat-sentinel]');
  var emptyEl = $('[data-cat-empty]');
  var sheet = $('[data-cat-sheet]');
  var showBtn = $('[data-cat-show]');
  var fcount = $('[data-cat-fcount]');

  var PRICE = [
    { id: 'u50', label: 'Under $50', test: function (v) { return v < 5000; } },
    { id: '50-200', label: '$50 – $200', test: function (v) { return v >= 5000 && v < 20000; } },
    { id: '200-500', label: '$200 – $500', test: function (v) { return v >= 20000 && v < 50000; } },
    { id: 'o500', label: '$500 and over', test: function (v) { return v >= 50000; } }
  ];

  /* Facet definitions: tag groups from the menu settings + spec fields */
  var facets = [];
  groups.forEach(function (g) {
    var key = g.t.toLowerCase().replace(/^shop by\s+/, '').replace(/[^a-z0-9]+/g, '-');
    facets.push({ key: key, title: g.t.replace(/^Shop by\s+/i, ''), type: 'tag', opts: g.o.map(function (o) { return { v: o[1], label: o[0] }; }) });
  });
  [['br', 'brand', 'Brand'], ['uf', 'use', 'Use for', ' · '], ['wr', 'weight', 'Weight rating'], ['mt', 'material', 'Material']].forEach(function (f) {
    facets.push({ key: f[1], title: f[2], type: 'field', field: f[0], split: f[3] || null, opts: null });
  });
  facets.push({ key: 'price', title: 'Price', type: 'price', opts: PRICE.map(function (p) { return { v: p.id, label: p.label }; }) });

  var state = { q: '', sort: mode === 'search' ? 'relevance' : 'featured', stock: false, sel: {} };
  var fixedTags = [];
  var items = [], results = [], shown = 0, base = [];
  /* v33: "picks" = a ranked list of records chosen by the Help-me-choose chooser (assets/aw-choose.js).
     While set, the grid shows those records (in rank order, facets and search still apply on top) and the
     pills row carries a "Your answers (N) ×" pill. picks.items may include products outside this collection
     when the chooser widened to the whole range. */
  var picks = null, corrected = '';

  /* ---------- URL state ---------- */
  function readURL() {
    var u = new URL(location.href);
    state.q = u.searchParams.get('q') || '';
    state.sort = u.searchParams.get('sort') || state.sort;
    state.stock = u.searchParams.get('stock') === '1';
    facets.forEach(function (f) {
      var v = u.searchParams.get(f.key);
      state.sel[f.key] = v ? v.split(',') : [];
    });
    fixedTags = [];
    presetTags.forEach(function (t) {
      var placed = false;
      facets.forEach(function (f) {
        if (f.type === 'tag' && f.opts.some(function (o) { return o.v === t; })) { placed = true; if (state.sel[f.key].indexOf(t) < 0) state.sel[f.key].push(t); }
      });
      if (!placed) fixedTags.push(t); // e.g. need-bathroom or brand-aidapt: not a filter group, so it always applies
    });
  }
  function writeURL() {
    var u = new URL(root.dataset.base || location.pathname, location.origin);
    var keep = new URL(location.href).searchParams;
    ['preview_theme_id', 'type', 'hmc'].forEach(function (k) { if (keep.get(k)) u.searchParams.set(k, keep.get(k)); }); // hmc = chooser answers
    if (state.q) u.searchParams.set('q', state.q);
    facets.forEach(function (f) { if (state.sel[f.key].length) u.searchParams.set(f.key, state.sel[f.key].join(',')); });
    if (state.stock) u.searchParams.set('stock', '1');
    if (state.sort !== (mode === 'search' ? 'relevance' : 'featured')) u.searchParams.set('sort', state.sort);
    history.replaceState(null, '', u.pathname + u.search);
  }

  /* ---------- Matching ---------- */
  function val(it, f) {
    if (f.type === 'field') { var fv = it[f.field]; if (!fv || fv === 'N/A') return []; return f.split ? String(fv).split(f.split).map(function (x) { return x.trim(); }).filter(Boolean) : [fv]; }
    if (f.type === 'price') { var id = []; PRICE.forEach(function (p) { if (p.test(it.per)) id.push(p.id); }); return id; }
    return it.tg || [];
  }
  function passes(it, skipKey) {
    if (state.stock && !it.a) return false;
    for (var k = 0; k < fixedTags.length; k++) if ((it.tg || []).indexOf(fixedTags[k]) < 0) return false;
    for (var i = 0; i < facets.length; i++) {
      var f = facets[i], sel = state.sel[f.key];
      if (f.key === skipKey || !sel.length) continue;
      var vs = val(it, f), ok = false;
      for (var j = 0; j < sel.length; j++) if (vs.indexOf(sel[j]) > -1) { ok = true; break; }
      if (!ok) return false;
    }
    return true;
  }
  function sortList(list) {
    var s = state.sort, out = list.slice();
    if (s === 'price-asc') out.sort(function (a, b) { return a.per - b.per; });
    else if (s === 'price-desc') out.sort(function (a, b) { return b.per - a.per; });
    else if (s === 'title') out.sort(function (a, b) { return a.t.localeCompare(b.t); });
    else if (s === 'newest') out.sort(function (a, b) { return b.d - a.d; });
    if (s !== 'relevance' && s !== 'featured') return out;
    // keep in-stock products first, otherwise the original order
    return out.map(function (it, i) { return { it: it, i: i }; }).sort(function (a, b) { return (b.it.a - a.it.a) || (a.i - b.i); }).map(function (o) { return o.it; });
  }

  /* ---------- Rendering ---------- */
  function facetOptions(f) {
    if (f.opts) return f.opts;
    var seen = {};
    items.forEach(function (it) { val(it, f).forEach(function (v) { seen[v] = (seen[v] || 0) + 1; }); });
    return Object.keys(seen).sort(function (a, b) { return seen[b] - seen[a] || a.localeCompare(b); }).map(function (v) { return { v: v, label: v }; });
  }
  var expanded = {};
  function renderFacets() {
    var wasOpen = {};
    $$('details.cat-f', facetsEl).forEach(function (d) { wasOpen[d.dataset.f] = d.open; });
    var html = '', hadOpen = Object.keys(wasOpen).length > 0, firstOpen = false;
    html += '<label class="cat-toggle"><input type="checkbox" data-stock' + (state.stock ? ' checked' : '') + '><span class="cat-toggle__ui" aria-hidden="true"></span><span>In stock only</span></label>';
    facets.forEach(function (f) {
      var pool = base.filter(function (it) { return passes(it, f.key); });
      var counts = {};
      pool.forEach(function (it) { val(it, f).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
      var sel = state.sel[f.key];
      var opts = facetOptions(f).filter(function (o) { return counts[o.v] || sel.indexOf(o.v) > -1; });
      if (!opts.length) return;
      // one filter group open at a time: keep what the shopper opened, otherwise open just the first group
      var open = hadOpen ? !!wasOpen[f.key] : !firstOpen;
      if (open) firstOpen = true;
      var many = opts.length > 8 && !expanded[f.key];
      html += '<details class="cat-f"' + (open ? ' open' : '') + ' data-f="' + f.key + '"><summary>' + X.esc(f.title) +
        (sel.length ? ' <b class="cat-f__n">' + sel.length + '</b>' : '') + '<span class="cat-f__chev" aria-hidden="true"></span></summary><div class="cat-f__opts' + (many ? ' is-clipped' : '') + '">';
      opts.forEach(function (o) {
        var on = sel.indexOf(o.v) > -1;
        html += '<button type="button" class="cat-opt' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-k="' + f.key + '" data-v="' + X.esc(o.v) + '"><span class="cat-opt__box" aria-hidden="true"></span><span class="cat-opt__l">' + X.esc(o.label) + '</span><span class="cat-opt__c">' + (counts[o.v] || 0) + '</span></button>';
      });
      html += '</div>' + (many ? '<button type="button" class="cat-f__more" data-more>Show all ' + opts.length + '</button>' : '') + '</details>';
    });
    facetsEl.innerHTML = html;
  }
  function renderPills() {
    var html = '';
    if (picks) html += '<button type="button" class="cat-pill cat-pill--picks" data-clear-picks>Your answers (' + picks.n + ') ✕</button>';
    if (state.q && mode === 'collection') html += '<button type="button" class="cat-pill" data-clear-q>“' + X.esc(state.q) + '” ✕</button>';
    if (state.stock) html += '<button type="button" class="cat-pill" data-stock-off>In stock ✕</button>';
    facets.forEach(function (f) {
      state.sel[f.key].forEach(function (v) {
        var o = (f.opts || []).filter(function (x) { return x.v === v; })[0];
        html += '<button type="button" class="cat-pill" data-k="' + f.key + '" data-v="' + X.esc(v) + '">' + X.esc(o ? o.label : v) + ' ✕</button>';
      });
    });
    if (html) html += '<button type="button" class="cat-pill cat-pill--clear" data-clear-all>Clear all</button>';
    pillsEl.innerHTML = html;
    pillsEl.hidden = !html;
    var n = (state.stock ? 1 : 0) + (picks ? 1 : 0) + facets.reduce(function (s, f) { return s + state.sel[f.key].length; }, 0);
    if (fcount) { fcount.textContent = n ? n : ''; fcount.hidden = !n; }
  }
  function renderCount() {
    var n = results.length;
    countEl.innerHTML = '<strong>' + n + '</strong> product' + (n === 1 ? '' : 's') + (state.q && mode === 'search' ? ' for “' + X.esc(state.q) + '”' : '') +
      (picks && picks.widened ? ' <small class="cat__count-note">from our whole range</small>' : picks ? ' <small class="cat__count-note">best match first</small>' : '') +
      (corrected ? ' <small class="cat__count-note">showing “' + X.esc(corrected) + '”</small>' : '');
    if (showBtn) showBtn.textContent = 'Show ' + n + ' product' + (n === 1 ? '' : 's');
  }
  function more() {
    if (shown >= results.length) return;
    var html = '';
    results.slice(shown, shown + BATCH).forEach(function (it) { html += X.card(it); });
    grid.insertAdjacentHTML('beforeend', html);
    shown = Math.min(results.length, shown + BATCH);
    if (moreEl) {
      moreEl.hidden = shown >= results.length;
      var t = $('[data-cat-progress]');
      if (t) t.textContent = 'Showing ' + shown + ' of ' + results.length;
    }
  }
  function apply(opts) {
    opts = opts || {};
    var pool = picks ? picks.items : items;
    corrected = '';
    if (state.q) {
      // v33: typo-tolerant search within these products ("rolator" → "rollator")
      var sr = X.searchFuzzy ? X.searchFuzzy(pool, state.q) : { items: X.search(pool, state.q), corrected: '' };
      base = sr.items; corrected = sr.corrected;
    } else base = pool;
    results = base.filter(function (it) { return passes(it); });
    if (picks && state.sort === (mode === 'search' ? 'relevance' : 'featured') && !state.q) results = results.slice(); // keep the chooser's rank order
    else if (!(state.q && state.sort === 'relevance')) results = sortList(results);
    else results = results.slice().sort(function (a, b) { return b.a - a.a; });
    grid.innerHTML = '';
    shown = 0;
    more();
    if (emptyEl) emptyEl.hidden = results.length > 0;
    renderCount(); renderPills(); renderFacets();
    if (!opts.silent) writeURL();
    document.dispatchEvent(new CustomEvent('cwcatalog:apply', { detail: { results: results, q: state.q, corrected: corrected, picks: !!picks } }));
    if (opts.scroll) {
      var top = root.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0) - 8;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  /* ---------- Events ---------- */
  function toggle(k, v) {
    var s = state.sel[k], i = s.indexOf(v);
    if (i > -1) s.splice(i, 1); else s.push(v);
    apply({ scroll: !sheetOpen() });
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;
    if (t.matches('.cat-opt, .cat-pill[data-k]')) { toggle(t.dataset.k, t.dataset.v); return; }
    if (t.hasAttribute('data-more')) { expanded[t.closest('details').dataset.f] = 1; var o = t.previousElementSibling; o.classList.remove('is-clipped'); t.remove(); return; }
    if (t.hasAttribute('data-stock-off')) { state.stock = false; apply(); return; }
    if (t.hasAttribute('data-clear-picks')) { clearPicks(); return; }
    if (t.hasAttribute('data-clear-q')) { state.q = ''; qEls.forEach(function (q) { q.value = ''; }); apply(); return; }
    if (t.hasAttribute('data-clear-all')) { state.stock = false; facets.forEach(function (f) { state.sel[f.key] = []; }); if (mode === 'collection') { state.q = ''; qEls.forEach(function (q) { q.value = ''; }); } if (picks) { picks = null; document.dispatchEvent(new CustomEvent('cwcatalog:picks', { detail: null })); } apply(); return; }
    if (t.hasAttribute('data-cat-open')) { openSheet(true); return; }
    if (t.hasAttribute('data-cat-close') || t.hasAttribute('data-cat-show')) { openSheet(false); return; }
    if (t.hasAttribute('data-cat-loadmore')) { more(); return; }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-stock]')) { state.stock = e.target.checked; apply(); }
    if (e.target === sortEl) { state.sort = sortEl.value; apply({ scroll: true }); }
  });
  var qt;
  qEls.forEach(function (q) {
    q.addEventListener('input', function () {
      clearTimeout(qt);
      qt = setTimeout(function () {
        state.q = q.value.trim();
        qEls.forEach(function (o) { if (o !== q) o.value = q.value; });
        if (mode === 'search') { var h = document.querySelector('[data-cat-heading]'); if (h) h.textContent = state.q ? 'Results for “' + state.q + '”' : 'Search products'; }
        apply();
      }, 150);
    });
    var f = q.closest('form');
    if (f) f.addEventListener('submit', function (e) { e.preventDefault(); state.q = q.value.trim(); apply({ scroll: true }); q.blur(); });
  });

  /* Mobile filter sheet */
  function sheetOpen() { return root.classList.contains('is-sheet-open'); }
  function openSheet(on) {
    root.classList.toggle('is-sheet-open', on);
    document.body.classList.toggle('no-scroll', on);
    if (sheet) { if (on) sheet.setAttribute('role', 'dialog'); else sheet.removeAttribute('role'); }
    if (!on) apply({ scroll: true, silent: true });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheetOpen()) openSheet(false); });

  /* Endless scroll */
  if (sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { if (en[0].isIntersecting) more(); }, { rootMargin: '900px 0px' }).observe(sentinel);
  }

  /* ---------- v33: public API for the Help-me-choose chooser ----------
     applyPicks(records, label, opts): records = index items in rank order (from this collection, or the whole
     range when opts.widened); label = pill text helper ("Your answers (N)"), opts.n = answered question count.
     clearPicks(): back to the normal grid. items(): this collection's index records once loaded. */
  function applyPicks(records, n, opts) {
    opts = opts || {};
    picks = { items: records || [], n: n || 0, widened: !!opts.widened };
    apply({ scroll: !!opts.scroll, silent: !!opts.silent });
  }
  function clearPicks(opts) {
    opts = opts || {};
    if (!picks) return;
    picks = null;
    document.dispatchEvent(new CustomEvent('cwcatalog:picks', { detail: null }));
    apply({ scroll: false, silent: !!opts.silent });
  }
  window.CWCatalog = {
    applyPicks: applyPicks, clearPicks: clearPicks,
    items: function () { return items; }, results: function () { return results; },
    hasPicks: function () { return !!picks; }, ready: function () { return root.classList.contains('is-ready'); },
    openSheet: function (on) { openSheet(on); }, query: function () { return state.q; },
    setQuery: function (q) { state.q = q || ''; qEls.forEach(function (o) { o.value = state.q; }); apply(); }
  };

  /* ---------- Boot ---------- */
  readURL();
  qEls.forEach(function (q) { if (state.q) q.value = state.q; });
  if (sortEl) sortEl.value = state.sort;
  root.classList.add('is-loading');
  X.load(root.dataset.src).then(function (list) {
    items = list;
    root.classList.remove('is-loading');
    root.classList.add('is-ready');
    apply({ silent: !location.search && !presetTags.length });
    document.dispatchEvent(new CustomEvent('cwcatalog:ready', { detail: { items: items } }));
  }).catch(function () {
    root.classList.remove('is-loading');
    root.classList.add('is-fallback');
  });
})();
